import dispatcher from "../Dispatcher";
import actionTypes from "./ActionTypes";
import axios from "axios";
import * as Globals from "../Globals";
import { Logout } from "./LoginActions";
import { PostAlert } from "./AlertActions";
export function GetCredentialList() {
  axios.get(`${Globals.baseUrl}/Credential/GetCredentials`, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`
    }
  }).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.CredentialList,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((res) => {
    let result = {
      updateStatus: "Error",
      errorMessage: "401: Bad request"
    };
    dispatcher.dispatch({
      actionType: actionTypes.CredentialList,
      Result: result
    });
  });
}
export function LoadCredential(id) {
  axios.post(
    `${Globals.baseUrl}/Credential/GetCredential`,
    { id },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.GetCredential,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((res) => {
    console.log("error");
  });
}
export function CreateCredential(credential) {
  console.log(credential);
  console.log("credential");
  axios.post(
    `${Globals.baseUrl}/Credential/CreateCredential`,
    {
      id: credential.id,
      name: credential.name,
      type: credential.type,
      clientId: credential.clientId,
      tenantId: credential.tenantId,
      clientSecret: credential.clientSecret,
      username: credential.username,
      password: credential.password,
      secret: credential.secret
    },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.CredentialCreate,
        Result: res.data
      });
      if (res.data.status === "Success") {
        PostAlert("success", "Credential created");
      }
      if (res.data.status === "Error") {
        PostAlert("error", "Unable to create credential");
        PostAlert("error", res.data.updateMessage);
      }
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function UpdateCredential(credential, clientSecretEncrypted, passwordEncrypted, secretEncrypted) {
  axios.post(
    `${Globals.baseUrl}/Credential/UpdateCredential`,
    {
      id: credential.id,
      name: credential.name,
      type: credential.type,
      clientId: credential.clientId,
      tenantId: credential.tenantId,
      clientSecret: credential.clientSecret,
      username: credential.username,
      password: credential.password,
      secret: credential.secret,
      clientSecretEncrypted,
      passwordEncrypted,
      secretEncrypted
    },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.CredentialUpdate,
        Result: res.data
      });
      if (res.data.status === "Success") {
        PostAlert("success", "Credential updated");
      }
      if (res.data.status === "Error") {
        PostAlert("error", "Unable to update credential");
        PostAlert("error", res.data.updateMessage);
      }
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function DeleteCredential(id) {
  console.log("there was an attempt");
  axios.post(
    `${Globals.baseUrl}/Credential/DeleteCredential`,
    { id },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.CredentialDelete,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
